import numeral from 'numeral'

export const lineCount = data => data.reduce((a, b) => a + b.additions + b.deletions, 0)

export const currentMRR = data => numeral(data[data.length - 1].y).format('$0,0.00')

export const totalTasks = data => data.reduce((a, b) => b > 0 ? a + b : a, 0)

export const totalUsers = data => numeral(data.reduce((a, b) => a + parseInt(b.y), 0)).format('0,0')